import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import createAssembly from './createAssembly';
import createTracks from "./createTracks";
import createDefaultSession from "./createDefaultSession";
import { CurrentSession } from './CurrentSession';
import JBrowseService from "../services/jbrowse.service";
import { Listbox } from '@headlessui/react';
import EventBus from "../common/EventBus";
import VcfModal from "./VcfModal";
import ToolsModal from "./ToolsModal";
import BigWigModal from "./BigWigModal";

import _ from 'underscore';
import dayjs from 'dayjs';
import { motion, AnimatePresence } from 'framer-motion';
import BuildIcon from '@mui/icons-material/Build';
import ListIcon from '@mui/icons-material/List';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import NoteIcon from '@mui/icons-material/Note';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveSessionModal from "./SaveSessionModal";
// import PanGenomeModal from "./PanGenomeModal";
import WarningIcon from '@mui/icons-material/Warning';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import BarChartSharp from '@mui/icons-material/BarChartSharp'
import { FormControlLabel, FormGroup } from '@mui/material';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import HandymanIcon from '@mui/icons-material/Handyman';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { toast } from 'react-toastify';
// Material-UI core components
import { Chip, Tooltip } from '@mui/material';

// Material-UI icons
import SettingsIcon from '@mui/icons-material/Settings';
import ArticleIcon from '@mui/icons-material/Article';

// Theme usage (add within your component function)

function WizardTool() {
    const [selectedCrop, setSelectedCrop] = useState("");
    const [selectedAssembly, setSelectedAssembly] = useState("");
    const [selectedTracks, setSelectedTracks] = useState([]);
    const [selectedPaf, setSelectedPaf ] = useState([]);
    const [availableAssemblies, setAvailableAssemblies] = useState([]);
    const [availableTracks, setAvailableTracks] = useState([]);
    // const [availablePaf, setAvailablePaf ] = useState([]);
    // const [projects, setProjects] = useState([]);
    const [crops, setCrops] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [currentAssembly, setCurrentAssembly] = useState(null);
    const [currentTracks, setCurrentTracks] = useState(null);
    const [currentSession, setCurrentSession] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null); // Selected project
    const [files, setFiles] = useState([]); // Files associated with selected project
    const [selectedFiles, setSelectedFiles] = useState([]); // User selected files
    const [isWizardVisible, setIsWizardVisible] = useState(true);
    const [chromosomes, setChromosomes] = useState([]);
    const [currentChromosome, setCurrentChromosome] = useState("");
    const [selectedVariants, setSelectedVariants] = useState([]);
    const [accessVariantIsOpen, setAccessVariantIsOpen] = useState(false);
    const [blastModalIsOpen, setBlastModalIsOpen] = useState(false);
    const [blastData, setBlastData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sampleNames, setSampleNames] = useState([]);
    const [notesIsOpen, setNotesIsOpen] = useState(false);
    const [notes, setNotes] = useState([]);
    const [vcfModalIsOpen, setVcfModalIsOpen] = useState(false);
    const [selectedVcfSamples, setSelectedVcfSamples] = useState([]);
    const [currentImage, setCurrentImage] = useState("");
    const [location, setLocation] = useState("");
    const [selectedVcf, setSelectedVcf ] = useState(false);
    const [saveAlert, setSaveAlert] = useState({
        visible: false,
        type: '', // 'success' or 'error'
        message: ''
    });
    const [state, setState] = useState(null);
    const [saveModalIsOpen, setSaveModalIsOpen] = useState(false);
    // const [showLiteratureSearch, setShowLiteratureSearch ] = useState(false);
    const [toggleLiteratureSearch, setToggleLiteratureSearch ] = useState(false);
    const [literatureModalIsOpen, setLiteratureModalIsOpen] = useState(false);
    // const [panGenomeModalIsOpen, setPanGenomeModalIsOpen ] = useState(false);
    const [ vcfWarning, setVcfWarning] = useState( false );
    const [alignmentLoading, setAlignmentLoading ] = useState(false );
    const [ alignmentError, setAlignmentError ] = useState( false );
    const [ showToolsModal, setShowToolsModal ] = useState( false );
    const [ bigWigModalIsOpen, setBigWigModalIsOpen ] = useState( false );

    const { user: currentUser } = useSelector((state) => state.auth);
    // console.log("current user: ", currentUser );

    const imgSrc = require("../img/jbrowse.png");

    // Init - Get Crops
    useEffect(() => {
        if (currentUser) {
            // Get Plants
            JBrowseService.getPlants(currentUser.email).then(
                (response) => {
                    console.log("plant response: ", response);
                    var filtered = _.filter(response, (value) => {
                        value.displayName = capitalizeFirstLetter(value.CommonName);
                        return value;
                    });
                    let sorted = _.sortBy(filtered, 'displayName');
                    // console.log("got crops: ", sorted);
                    setCrops(sorted);
                    setSelectedCrop("");
                    setSelectedVcf( false );
                    setSelectedPaf([]);
                },
                (error) => {
                    console.log("error: ", error);
                    if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_REQUEST") {
                        console.warn("logout!!!");
                        EventBus.dispatch("logout");
                    }
                }
            );

        } else {
            console.log("no user found..");
        }
    }, [currentUser]);

    useEffect(() => {
        // setAvailableAssemblies(assemblies[selectedCrop]);
        setSelectedAssembly("");
        setSelectedTracks([]);
        // console.log("got crop...", availableAssemblies);
    }, [selectedCrop]);

    useEffect(() => {
        // setAvailableTracks(tracks[selectedAssembly]);
        setSelectedTracks([]);
        // console.log("assembly: ", selectedAssembly );
        // Send Request
        if (selectedAssembly !== "" && currentUser && currentUser?.DirectoryName ) {
            let obj = {
                company: currentUser.DirectoryName,
                assembly: selectedAssembly
            };
            JBrowseService.getChromosomes( obj ).then(
                (response) => {
                    // console.log("chromosome response: ", response);
                    var arr = parsePythonList(response.result)
                    // console.log("type: ", typeof arr )
                    // console.log('arr: ', arr );
                    setChromosomes(arr);
                    setCurrentChromosome(arr[0]);

                },
                (error) => {
                    console.log("error: ", error);
                }
            )
        }

    }, [selectedAssembly, currentUser]);

    useEffect(() => {
        if (selectedProject && selectedProject.Company_Code && selectedProject.Code && currentUser) {
            var obj = {
                company: selectedProject.Company_Code,
                code: selectedProject.Code,
                assembly: selectedAssembly,
                user: currentUser.email
            };
            // Send Request
            JBrowseService.getBamFiles(obj).then(
                (response) => {
                    console.log("bam response: ", response);
                    if (response.status === 0) {
                        setFiles(response.result);
                    } else {
                        // Show error temporarily
                        setAlignmentError(true);
                        setTimeout(function () {
                            setAlignmentError(false);
                        }, 3000);
                    }
                },
                (error) => {
                    console.log("bam error: ", error);
                }
            )
        }
    }, [selectedProject, currentUser?.email, selectedAssembly]);

    useEffect( () => {
        if( selectedTracks.length > 0 ) {
            console.log("tracks: ", selectedTracks );
            const vcfFiles = selectedTracks.filter(file => file.endsWith('.vcf'));
            console.log("vcf: ", vcfFiles );
            if( vcfFiles.length > 0 ) {
                console.log("user selected vcf.");
                setSelectedVcf( true )
            }
        }
    }, [selectedTracks] );

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleCropChange = (value) => {
        console.log("crop: ", value);
        setSelectedCrop(value);
        let assembly = {}
        assembly[value] = [];

        const idSpecies = crops.find(crop => crop.displayName === value).idSpecies;
        console.log("idSpecies: ", idSpecies);

        // Image 
        _.each(crops, (val) => {
            if (val.displayName === value) {
                setCurrentImage(val.WebImage);
            }
        });

        var obj = {
            crop: value,
            idSpecies: idSpecies,
            company: currentUser.DirectoryName,
            user: currentUser.username
        };
        console.log("request obj: ", obj);
        // return;
        // Get Assemblies
        JBrowseService.getAssembliesFromDirectory(obj).then(
            (response) => {
                console.log("assemblies response: ", response);
                var options = _.filter(response, function (value) {
                    return value.Name;
                });
                let sorted = _.sortBy(options, 'Name');
                assembly[value] = sorted

                // console.log("assembly: ", assembly);
                // Update state based on the response
                setAvailableAssemblies(assembly[value]);
            },
            (error) => {
                console.log("error: ", error);
                if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_RESPONSE") {
                    console.warn("logout!!!");
                    EventBus.dispatch("logout");
                }
            }
        )
    };

    const handleAssemblyChange = (value) => {
        console.log("selected: ", selectedAssembly );
        // console.log("avaialbe: ", availableAssemblies );
        // console.log("value: ", value );
        setSelectedAssembly(value);
        let tracks = {};
        tracks[value] = [];
        let file = value;
        console.log("tracks: ", tracks);

        const idReferenceGenome = availableAssemblies.find(assembly => assembly.Name === value).idReferenceGenome;
    
        var obj = {
            assembly: value,
            user: currentUser.username,
            company: currentUser.DirectoryName,
            idReferenceGenome: idReferenceGenome,
        };
        console.log("obj: ", obj );
        // return;
    
        // Send Request
        JBrowseService.getTracksFromDirectory(obj).then(
            (response) => {
                console.log("tracks response: ", response);
    
                // Process GFFs
                if (response.gffs && response.gffs.length > 0) {
                    let GFFs = response.gffs.map(gff => {
                        if (gff.FilePath) {
                            gff.FileName = getFileName(gff.FilePath);
                        }
                        return gff;
                    });
    
                    // Remove duplicates based on GFF_FileName
                    GFFs = _.uniq(GFFs, 'FileName');
    
                    GFFs.forEach((gff) => {
                        tracks[file].push(gff);
                    });
                }
    
                // Process VCFs
                if (response.vcfs && response.vcfs.length > 0) {
                    let VCFs = response.vcfs.filter(vcf => vcf.Active !== 1).map(vcf => {
                        return vcf;
                    });
    
                    VCFs.forEach((vcf) => {
                        tracks[file].push(vcf);
                    });
                }
    
                // Sort tracks by 'FileName'
                let sortedTracks = _.sortBy(tracks[file], 'FileName');
                console.log("after sorting: ", sortedTracks);
    
                // Set the available tracks
                setAvailableTracks(sortedTracks);
            },
            (error) => {
                console.log("error: ", error);
                if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_RESPONSE") {
                    console.warn("logout!!!");
                    EventBus.dispatch("logout");
                }
            }
        );
    };
    
    const handleTrackChange = (value) => {
        if (!selectedTracks.includes(value)) {
            // Check if track is a vcf 
            let vcf_check = value.includes(".vcf");
            if (vcf_check) {
                setLoading(true);
                // Get Samples, then show modal 
                let obj = {
                    file: value,
                    ref: selectedAssembly,
                    user: currentUser.email,
                    company: currentUser.DirectoryName
                }
                console.log("obj: ", obj);
                // Send Request
                JBrowseService.getSampleNames(obj).then(
                    (response) => {
                        console.log("samples response: ", response);
                        let samples = response.result.output;
                        if( samples[0] === "An error occurred") {
                            console.log('bad vcf file..');
                            setLoading(false);
                            setVcfWarning( true );
                            setTimeout( () => {
                                setVcfWarning( false );
                            },3000 );
                        } else {
                            let updated_samples = _.map( samples, ( value ) => {
                                // console.log("value ", value );
                                return value+"_"+response.idVCFFile;
                            });
                            // console.log("updated: ", updated_samples );

                            setSelectedTracks([...selectedTracks, value]);
                            setSampleNames( updated_samples );
                            setVcfModalIsOpen(true);
                            setLoading(false);
                        }

                    },
                    (error) => {
                        console.log('error: ', error);
                        setLoading(false);
                        if (error.code === "ERR_NETWORK") {
                            console.warn("logout!!!");
                            EventBus.dispatch("logout");
                        }
                    }
                )
            } else {
                setSelectedTracks([...selectedTracks, value]);
            }

        } else {
            // alert('This track has already been selected. Please choose a different track.');
            toast.info("This track has already been selected. Please choose a different track.");
        }
    };

    const handleBuildClick = () => {
        setLoading(true)
        setIsWizardVisible(false);

        const myAssembly = createAssembly(selectedAssembly);
        // console.log("assembly config: ", myAssembly);
        setCurrentAssembly(myAssembly);

        // console.log('selected: ', selectedTracks);
        const filteredTracks = selectedTracks.filter(file => !file.endsWith('notes.gff'));
        console.log("filteredTracks: ", filteredTracks );
        // return;

        if( selectedPaf.length > 0 ) {
            console.log("found selected paf: ", selectedPaf );
            filteredTracks.push( selectedPaf[0].fileName );
        }

        // return;

        (async () => {
            const company = currentUser.DirectoryName;
            const myTracks = await createTracks(selectedAssembly, filteredTracks, company );
            // console.log('tracks: ', myTracks);
            // Update PAF Track..
            let trackToUpdate = myTracks.find(track => track.type === "SyntenyTrack");
            // console.log("check: ", trackToUpdate);
            if (trackToUpdate) {
                trackToUpdate.assemblyNames = [ selectedPaf[0].query_genome_name, selectedPaf[0].subject_genome_name ];
                trackToUpdate.adapter.assemblyNames = [ selectedPaf[0].query_genome_name, selectedPaf[0].subject_genome_name ];
            }
            // Set Current Tracks
            console.log("tracks after: ", myTracks );

            setCurrentTracks(myTracks);
        })();

        // return;

        // const myTracks = createTracks(selectedAssembly, selectedTracks);
        // console.log('tracks: ', myTracks);
        // setCurrentTracks(myTracks);
        console.log("filtered after: ", filteredTracks );

        const defaultSession = createDefaultSession(selectedAssembly, filteredTracks);
        console.log("defaultSession: ", defaultSession);
        setCurrentSession(defaultSession);
        // return;

        // Get Notes
        let notes_obj = {
            idCompany: currentUser.idCompany,
            username: currentUser.email,
            assembly: selectedAssembly,
        };
        console.log("notes obj: ", notes_obj);

        // Send Request
        JBrowseService.getNotes(notes_obj).then(
            (response) => {
                console.log("notes response: ", response);
                let notes = []
                // Loop through notes results and fix url strings
                _.each(response.result, function (value) {
                    var obj = value;
                    obj.created_at = dayjs(value.created_at).format('MMMM D YYYY, h:mm:ss A');
                    notes.push(obj);
                });
                // console.log("notes: ", notes );
                setNotes(notes);
            },
            (error) => {
                console.log("error: ", error);
                if (error.code === "ERR_NETWORK") {
                    console.warn("logout!!!");
                    EventBus.dispatch("logout");
                }
            }
        )

        // Send Request
        // JBrowseService.destroyBlastDirectory({ user: currentUser.email }).then(
        //     (response) => {
        //         console.log("destroy response: ", response);
        //     },
        //     (error) => {
        //         console.log("error: ", error);
        //     }
        // )

    }

    // const handleProjectChange = (e) => {
    //     const projectId = e.target.value;
    //     const project = projects.find(p => p.idProject == projectId);
    //     setSelectedProject(project);
    //     setSelectedFiles([]); // Reset selected files when project changes
    // };

    const handleBamChange = (e) => {
        console.log("file: ", e.target.value);
        if (e.target.checked) {
            setSelectedFiles(prevFiles => [...prevFiles, e.target.value]);
            setSelectedTracks([...selectedTracks, e.target.value]);
        } else {
            setSelectedFiles(prevFiles => prevFiles.filter(fileId => fileId !== e.target.value));
            setSelectedTracks(prevTracks => prevTracks.filter(fileId => fileId !== e.target.value));
        }
    };

    const removeTrack = (track, listName) => {
        if (listName === 'selectedTracks') {
            // console.log("track: ", track );
            setSelectedTracks(prevTracks => prevTracks.filter(t => t !== track));
            setSelectedVcfSamples(prevTracks => prevTracks.filter(t => t !== track ));
        } else if (listName === 'selectedFiles') {
            setSelectedFiles(prevFiles => prevFiles.filter(f => f !== track));
        } else if( listName === 'selectedPaf') {
            setSelectedPaf( prevFiles => prevFiles.filter(f => f !== track) )
        }
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedProject(null);
    }

    const openModal = () => {
        console.log("current User: ", currentUser );
        setFiles([]);
        setIsOpen(true);
        setAlignmentLoading( true );
        // Send Request 
        // Get Bam Files
        let bamObj = {
            user: currentUser.email,
            company: currentUser.DirectoryName,
            idCompany: currentUser.idCompany,
            assembly: selectedAssembly,
        };
        console.log("obj: ", bamObj);

        JBrowseService.getLocalBamFiles(bamObj).then(
            (response) => {
                console.log("local bam response: ", response);
                let formattedResponse = response.result.map( file => {
                    let obj = {
                        filepath: response.path+file,
                        filename: file
                    }
                    return obj;
                });
                console.log("formmated: ", formattedResponse );
                setFiles( formattedResponse );
                setAlignmentLoading( false );
            },
            (error) => {
                console.log('error: ', error);
                setAlignmentLoading( false );
                setAlignmentError( true );
                setTimeout( ()=> {
                    setAlignmentError( false );
                },5000);
            }
        )
        // let obj = {
        //     user: currentUser.email,
        //     company: currentUser.company,
        //     assembly: selectedAssembly
        // };
        // console.log("obj: ", obj );
        // JBrowseService.getAvailableBamFiles( obj ).then(
        //     (response) => {
        //         console.log("bam response: ", response);
        //         // Post-processing the response to filter out .bai files and get file names
        //         const processedResponse = response.map(project => ({
        //             ...project,
        //             files: project.files
        //                 .filter(file => file.endsWith('.bam')) // Keep only .bam files
        //                 .map(file => ({
        //                     filepath: file,
        //                     filename: file.split('/').pop()
        //                 })) // Create an object with filepath and filename
        //         }));
        //         console.log("proccess: ", processedResponse );

        //         setFiles(processedResponse);
        //     },
        //     (error) => {
        //         console.log("error: ", error);
        //     }
        // )

        // JBrowseService.getProjects({ id: currentUser.idCompany }).then(
        //     (response) => {
        //         // console.log("response: ", response);
        //         setProjects(response);
        //     },
        //     (error) => {
        //         console.log("projects error: ", error);
        //     }
        // )
    }

    const toggleWizard = () => {
        setIsWizardVisible(!isWizardVisible);
    };

    const toggleVariants = () => {
        // console.log("got here: ", accessVariantIsOpen );
        setAccessVariantIsOpen(true);
    }

    const toggleNotes = () => {
        setNotesIsOpen(true);
    }

    const toggleBlast = () => {
        setBlastModalIsOpen(true);
    }

    const toggleSavedSession = () => {
        setSaveModalIsOpen( true )
    }

    const destroySession = () => {
        setState( null );
        setIsWizardVisible( true );
        setSelectedVcfSamples([]);
        setCurrentSession(null);
        setSelectedVariants([]);
        setSelectedAssembly("");
        setSelectedTracks([]);
        setSelectedCrop("");
        setSelectedFiles([]);
        setBlastData([]);
        setNotes([]);
        setToggleLiteratureSearch( false );
        // setShowLiteratureSearch( false );
        setSelectedVcf( false );
        // setAvailablePaf([]);
        setSelectedPaf([]);
    }

    const handleLiteratureSearch = () => {
        setToggleLiteratureSearch( true );
        setLiteratureModalIsOpen( true );
    };

    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
    };

    const filteredFiles = files.filter(file =>
        file.filename.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!currentUser) {
        console.warn("got here and transitioned ")
        return <Navigate to="/" />;
    }

    return (
        <>
            {loading && (
                <div className='loading'></div>
            )}
            {/* Buttons */}
            <div className="container-fluid">
                {/* Toggle View */}
                {currentSession && (
                    <>
                        <Button
                            variant="contained"
                            startIcon={<DeleteForeverIcon />}
                            onClick={destroySession}
                            sx={{
                                minWidth: 'unset',  // Remove default min-width
                                padding: '8px 14px', // Compact padding
                                fontSize: '0.775rem',
                                backgroundColor: 'grey.600',
                                '&:hover': { backgroundColor: 'grey.800' },
                                ml: 1,
                                mb: 1,
                            }}
                            disableElevation
                        >
                            Destroy Session
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            onClick={toggleSavedSession}
                            sx={{
                                minWidth: 'unset',  // Remove default min-width
                                padding: '8px 14px', // Compact padding
                                fontSize: '0.775rem',
                                backgroundColor: 'grey.600',
                                '&:hover': { backgroundColor: 'grey.800' },
                                ml: 1,
                                mb: 1,
                            }}
                            disableElevation
                        >
                            Save Session
                        </Button>

                        {notes.length > 0 && (
                            <Button
                                variant="contained"
                                startIcon={<NoteIcon />}
                                onClick={toggleNotes}
                                sx={{
                                    minWidth: 'unset',  // Remove default min-width
                                    padding: '8px 14px', // Compact padding
                                    fontSize: '0.775rem',
                                    backgroundColor: 'grey.600',
                                    '&:hover': { backgroundColor: 'grey.800' },
                                    ml: 1,
                                    mb: 1,
                                }}
                                disableElevation
                            >
                                Notes
                            </Button>
                        )}

                        <Button
                            variant="contained"
                            startIcon={<ListAltIcon />}
                            onClick={toggleVariants}
                            sx={{
                                minWidth: 'unset',  // Remove default min-width
                                padding: '8px 14px', // Compact padding
                                fontSize: '0.775rem',
                                backgroundColor: 'grey.600',
                                '&:hover': { backgroundColor: 'grey.800' },
                                ml: 1,
                                mb: 1,
                            }}
                            disableElevation
                        >
                            Access Variants
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={<SearchIcon />}
                            onClick={toggleBlast}
                            sx={{
                                minWidth: 'unset',  // Remove default min-width
                                padding: '8px 14px', // Compact padding
                                fontSize: '0.775rem',
                                backgroundColor: 'grey.600',
                                '&:hover': { backgroundColor: 'grey.800' },
                                ml: 1,
                                mb: 1,
                            }}
                            disableElevation
                        >
                            Blast
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={<HandymanIcon />}
                            onClick={() => setShowToolsModal(true)}
                            sx={{
                                minWidth: 'unset',  // Remove default min-width
                                padding: '8px 14px', // Compact padding
                                fontSize: '0.775rem',
                                backgroundColor: 'grey.600',
                                '&:hover': { backgroundColor: 'grey.800' },
                                ml: 1,
                                mb: 1,
                            }}
                            disableElevation
                        >
                            Tools
                        </Button>
                    </>
                )}
            </div>

            {/* Save Alert */}
            {saveAlert.visible && (
                <div className={`saveAlert fixed top-4 left-1/2 transform -translate-x-1/2 p-4 rounded-lg shadow-2xl ${saveAlert.type === 'success' ? 'bg-green-600' : 'bg-red-600'} text-white z-50 transition-transform duration-300`}>
                    <span className="block mr-4">{saveAlert.message}</span>
                    <button className="absolute top-2 right-2 focus:outline-none" onClick={() => setSaveAlert({ ...saveAlert, visible: false })}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414L11.414 13l2.293 2.293a1 1 0 01-1.414 1.414L10 14.414l-2.293 2.293a1 1 0 01-1.414-1.414L8.586 13 6.293 10.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            )}

            {/* Wizard Tool */}
            <AnimatePresence>
                {isWizardVisible && (
                    <motion.div
                        initial={{ opacity: 0, x: '-100%' }}
                        animate={{ opacity: 1, x: '0%' }}
                        exit={{ opacity: 0, x: '-100%' }}
                        transition={{ duration: 0.5 }}
                        style={{ marginBottom: '1rem' }}
                    >
                        <Paper
                            elevation={0} 
                            sx={{
                                p: 3,
                                backgroundColor: 'white',
                                width: '100%',
                                transition: 'opacity 0.5s, box-shadow 0.3s',
                                opacity: isWizardVisible ? 1 : 0,
                                zIndex: 100000,
                                borderRadius: 3, // Slightly more rounded corners
                                boxShadow: '0 4px 20px rgba(69, 88, 115, 0.1), 0 2px 8px rgba(69, 88, 115, 0.05)', // Layered shadows
                                '&:hover': {
                                    boxShadow: '0 8px 24px rgba(69, 88, 115, 0.15), 0 4px 12px rgba(69, 88, 115, 0.08)' // Interactive state
                                }
                            }}
                        >

                            <Box display="flex" flexDirection="column" p={0}>
                                <Box
                                    display="flex"
                                    flexDirection={{ xs: 'column', md: 'row' }}
                                    gap={4}
                                    width="100%"
                                >
                                    {/* Left Column */}
                                    <Box flex="1" display="flex" flexDirection="column" gap={3}>
                                        <Box mb={1} display="flex" flexDirection="column">
                                            <Box display="flex" alignItems="center" gap={2} mb={1}>
                                                <img src={imgSrc} alt="logo" style={{ height: '48px' }} />
                                                <Box>
                                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                                        JBrowse 2 Wizard
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        developed by Verinomics
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {/* <Divider sx={{ my: 2 }} /> */}
                                        </Box>

                                        {/* Crop Selection */}
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                Crop
                                            </Typography>
                                            <Listbox value={selectedCrop} onChange={handleCropChange} id="plant-dropdown">
                                                {({ open }) => (
                                                    <>
                                                        <Box sx={{ position: 'relative' }}>
                                                            <Listbox.Button
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '12px 16px',
                                                                    textAlign: 'left',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    transition: 'all 0.2s',
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                                    '&:hover': {
                                                                        borderColor: '#1976d2',
                                                                    }
                                                                }}
                                                            >
                                                                {selectedCrop || 'Select Crop'}
                                                                <svg
                                                                    style={{ height: '20px', width: '20px', color: '#757575' }}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </Listbox.Button>
                                                            <Listbox.Options
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: '100%',
                                                                    marginTop: '0.5rem',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                                    zIndex: 20,
                                                                    maxHeight: '16rem',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {crops.map((crop, index) => (
                                                                    <Listbox.Option key={index} value={crop.displayName}>
                                                                        {({ active, selected }) => (
                                                                            <Box
                                                                                sx={{
                                                                                    cursor: 'pointer',
                                                                                    px: 3,
                                                                                    py: 1.5,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    backgroundColor: active ? 'primary.light' : 'inherit',
                                                                                    color: active ? 'primary.dark' : 'inherit',
                                                                                    borderRadius: '4px',
                                                                                    mx: 0.5,
                                                                                    my: 0.5,
                                                                                    '&:hover': {
                                                                                        backgroundColor: 'primary.light',
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>{crop.displayName}</span>
                                                                                {selected && (
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 24 24"
                                                                                        fill="currentColor"
                                                                                        aria-hidden="true"
                                                                                        style={{ color: '#1976d2' }}
                                                                                    >
                                                                                        <path d="m9 19.414-6.707-6.707 1.414-1.414L9 16.586l11.293-11.293 1.414 1.414z" />
                                                                                    </svg>
                                                                                )}
                                                                            </Box>
                                                                        )}
                                                                    </Listbox.Option>
                                                                ))}
                                                            </Listbox.Options>
                                                        </Box>
                                                    </>
                                                )}
                                            </Listbox>
                                        </Box>

                                        {/* Assembly Selection */}
                                        {selectedCrop && availableAssemblies && (
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                    Assembly
                                                </Typography>
                                                <Listbox value={selectedAssembly} onChange={handleAssemblyChange} id="assembly-dropdown">
                                                    {({ open }) => (
                                                        <Box sx={{ position: 'relative' }}>
                                                            <Listbox.Button
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '12px 16px',
                                                                    textAlign: 'left',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    transition: 'all 0.2s',
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                                    '&:hover': {
                                                                        borderColor: '#1976d2',
                                                                    }
                                                                }}
                                                            >
                                                                {selectedAssembly || 'Select Assembly'}
                                                                <svg
                                                                    style={{ height: '20px', width: '20px', color: '#757575' }}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </Listbox.Button>
                                                            <Listbox.Options
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: '100%',
                                                                    marginTop: '0.5rem',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                                    zIndex: 20,
                                                                    maxHeight: '16rem',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {availableAssemblies.map((assembly, index) => (
                                                                    <Listbox.Option key={index} value={assembly.Name}>
                                                                        {({ active, selected }) => (
                                                                            <Box
                                                                                sx={{
                                                                                    cursor: 'pointer',
                                                                                    px: 3,
                                                                                    py: 1.5,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    backgroundColor: active ? 'primary.light' : 'inherit',
                                                                                    color: active ? 'primary.dark' : 'inherit',
                                                                                    borderRadius: '4px',
                                                                                    mx: 0.5,
                                                                                    my: 0.5,
                                                                                    '&:hover': {
                                                                                        backgroundColor: 'primary.light',
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>{assembly.Name}</span>
                                                                                {selected && (
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 24 24"
                                                                                        fill="currentColor"
                                                                                        style={{ color: '#1976d2' }}
                                                                                        aria-hidden="true"
                                                                                    >
                                                                                        <path d="m9 19.414-6.707-6.707 1.414-1.414L9 16.586l11.293-11.293 1.414 1.414z" />
                                                                                    </svg>
                                                                                )}
                                                                            </Box>
                                                                        )}
                                                                    </Listbox.Option>
                                                                ))}
                                                            </Listbox.Options>
                                                        </Box>
                                                    )}
                                                </Listbox>
                                            </Box>
                                        )}

                                        {/* Track Selection */}
                                        {selectedAssembly && availableTracks && (
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                                    Tracks
                                                </Typography>
                                                <Listbox value={selectedTracks} onChange={handleTrackChange} id="track-dropdown">
                                                    {({ open }) => (
                                                        <Box sx={{ position: 'relative' }}>
                                                            <Listbox.Button
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '12px 16px',
                                                                    textAlign: 'left',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    transition: 'all 0.2s',
                                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                                    '&:hover': {
                                                                        borderColor: '#1976d2',
                                                                    }
                                                                }}
                                                            >
                                                                {selectedTracks.length > 1
                                                                    ? `${selectedTracks[0]} + ${selectedTracks.length - 1} more`
                                                                    : selectedTracks[0] || 'Select Tracks'}
                                                                <svg
                                                                    style={{ height: '20px', width: '20px', color: '#757575' }}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </Listbox.Button>
                                                            <Listbox.Options
                                                                style={{
                                                                    position: 'absolute',
                                                                    width: '100%',
                                                                    marginTop: '0.5rem',
                                                                    background: 'white',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                                    zIndex: 10,
                                                                    maxHeight: '16rem',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {availableTracks.map((track, index) => (
                                                                    <Listbox.Option key={index} value={track.FileName}>
                                                                        {({ active, selected }) => (
                                                                            <Box
                                                                                sx={{
                                                                                    cursor: 'pointer',
                                                                                    px: 3,
                                                                                    py: 1.5,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'space-between',
                                                                                    backgroundColor: active ? 'primary.light' : 'inherit',
                                                                                    color: active ? 'primary.dark' : 'inherit',
                                                                                    borderRadius: '4px',
                                                                                    mx: 0.5,
                                                                                    my: 0.5,
                                                                                    '&:hover': {
                                                                                        backgroundColor: 'primary.light',
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span>{track.FileName}</span>
                                                                                {selected && (
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 24 24"
                                                                                        fill="currentColor"
                                                                                        style={{ color: '#1976d2' }}
                                                                                        aria-hidden="true"
                                                                                    >
                                                                                        <path d="m9 19.414-6.707-6.707 1.414-1.414L9 16.586l11.293-11.293 1.414 1.414z" />
                                                                                    </svg>
                                                                                )}
                                                                            </Box>
                                                                        )}
                                                                    </Listbox.Option>
                                                                ))}
                                                            </Listbox.Options>
                                                        </Box>
                                                    )}
                                                </Listbox>
                                            </Box>
                                        )}

                                        {/* Build & Alignment */}
                                        {selectedAssembly && selectedTracks.length > 0 && (
                                            <Box display="flex" gap={2} mt={2} flexWrap="wrap">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleBuildClick}
                                                    startIcon={<BuildIcon />}
                                                    size="large"
                                                    sx={{
                                                        borderRadius: 2,
                                                        px: 3,
                                                        py: 1.2,
                                                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                                                        transition: 'all 0.3s',
                                                        '&:hover': {
                                                            transform: 'translateY(-2px)',
                                                            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                                                        }
                                                    }}
                                                >
                                                    Build JBrowse
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={openModal}
                                                    startIcon={<ListIcon />}
                                                    size="large"
                                                    sx={{
                                                        borderRadius: 2,
                                                        px: 3,
                                                        py: 1.2,
                                                        transition: 'all 0.3s',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                        }
                                                    }}
                                                >
                                                    Alignment Tracks
                                                </Button>
                                            </Box>
                                        )}

                                        {/* VCF and BigWig Tracks */}
                                        {selectedAssembly && (
                                            <Box display="flex" gap={2} mt={2} flexWrap="wrap">
                                                {selectedVcf && (
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            setVcfModalIsOpen(true);
                                                        }}
                                                        startIcon={<InsertDriveFileIcon />}
                                                        size="large"
                                                        sx={{
                                                            borderRadius: 2,
                                                            px: 3,
                                                            py: 1.2,
                                                        }}
                                                    >
                                                        VCF Samples
                                                    </Button>
                                                )}
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => {
                                                        setBigWigModalIsOpen(true);
                                                    }}
                                                    startIcon={<BarChartSharp />}
                                                    size="large"
                                                    sx={{
                                                        borderRadius: 2,
                                                        px: 3,
                                                        py: 1.2,
                                                    }}
                                                >
                                                    Select BigWig Tracks
                                                </Button>
                                            </Box>
                                        )}

                                        {vcfWarning && (
                                            <Alert
                                                severity="warning"
                                                variant="filled"
                                                sx={{
                                                    mt: 2,
                                                    borderRadius: 2,
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box display="flex" alignItems="center">
                                                    <WarningIcon sx={{ marginRight: '8px' }} />
                                                    There was an error with that VCF file. Contact a Verinomics engineer.
                                                </Box>
                                            </Alert>
                                        )}
                                    </Box>

                                    {/* Right Side */}
                                    <Box
                                        flex="1"
                                        className="flex flex-col gap-5 bg-white rounded-xl shadow-sm p-6"
                                    >
                                        {!selectedCrop ? (
                                            <div className="flex flex-col items-center justify-center h-full py-10 text-center">
                                                <SettingsIcon className="text-gray-400 mb-4" style={{ fontSize: '3rem' }} />
                                                <Typography
                                                    variant="h6"
                                                    className="font-bold text-gray-700 mb-2"
                                                >
                                                    Start Building Your JBrowse Session
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    className="text-gray-500 max-w-md"
                                                >
                                                    Select a Crop, Genome and Track files from the options on the left to configure your JBrowse session.
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    className="text-gray-500 max-w-md mt-4 pt-4 border-t border-gray-100"
                                                >
                                                    Once you build a session, you can save the configurations so you can easily jump back into a working session with your desired settings.
                                                </Typography>
                                                <Button
                                                    component={Link}
                                                    to="/sessions"
                                                    variant="contained"
                                                    startIcon={<SaveIcon />}
                                                    className="mt-4"
                                                    sx={{ 
                                                    mb: 2, 
                                                    background: 'linear-gradient(45deg, #4F7D24 30%, #5C9029 90%)',
                                                    color: 'white',
                                                    borderRadius: 2,
                                                    boxShadow: '0 8px 16px rgba(79, 125, 36, 0.2)',
                                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                    ':hover': { 
                                                        background: 'linear-gradient(45deg, #446B1F 30%, #4F7D24 90%)',
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: '0 12px 20px rgba(79, 125, 36, 0.3)',
                                                        color: '#f5f5f5',
                                                        '& .MuiSvgIcon-root': {
                                                        color: '#f5f5f5'
                                                        }
                                                    }
                                                    }}
                                                >
                                                    Saved Sessions
                                                </Button>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="flex items-center gap-3 pb-4 border-b border-gray-100">
                                                    <SettingsIcon className="text-green-600" fontSize="medium" />
                                                    <Typography
                                                        variant="h5"
                                                        className="font-bold text-gray-800"
                                                    >
                                                        Current Session Configuration
                                                    </Typography>
                                                </div>

                                                {selectedCrop && (
                                                    <div className="bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:shadow-md">
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                <div className="w-2 h-10 bg-green-500 rounded-full"></div>
                                                                <Typography variant="subtitle1" className="font-semibold text-gray-700">
                                                                    Selected Crop
                                                                </Typography>
                                                            </div>
                                                            <div className="flex items-center gap-3">
                                                                <Chip
                                                                    label={selectedCrop}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                    className="font-medium"
                                                                />
                                                                <div className="w-12 h-12 bg-white rounded-lg p-1 shadow-sm flex items-center justify-center overflow-hidden transition-transform duration-300 hover:scale-110">
                                                                    <img
                                                                        src={currentImage}
                                                                        alt="WebImage"
                                                                        className="max-h-full max-w-full object-contain"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {selectedAssembly && (
                                                    <div className="bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:shadow-md">
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                <div className="w-2 h-10 bg-green-500 rounded-full"></div>
                                                                <Typography variant="subtitle1" className="font-semibold text-gray-700">
                                                                    Selected Assembly
                                                                </Typography>
                                                            </div>
                                                            <Chip
                                                                label={selectedAssembly}
                                                                color="primary"
                                                                variant="outlined"
                                                                className="font-medium"
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {selectedTracks.length > 0 && (
                                                    <div className="bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:shadow-md">
                                                        <div className="flex items-center gap-2 mb-3">
                                                            <div className="w-2 h-10 bg-green-500 rounded-full"></div>
                                                            <Typography variant="subtitle1" className="font-semibold text-gray-700">
                                                                Selected Tracks
                                                            </Typography>
                                                        </div>
                                                        
                                                        <div className="max-h-[240px] overflow-y-auto rounded-lg bg-white border border-gray-200 shadow-inner">
                                                            {selectedTracks
                                                                .filter((track) => !track.endsWith('.bam'))
                                                                .map((track, index) => {
                                                                    const fileName = track.split('/').pop();
                                                                    const isLast = index === selectedTracks.filter(t => !t.endsWith('.bam')).length - 1;
                                                                    
                                                                    return (
                                                                        <div 
                                                                            key={index}
                                                                            className={`flex items-center justify-between py-3 px-4 ${!isLast ? 'border-b border-gray-100' : ''} hover:bg-gray-50 group transition-colors duration-200`}
                                                                        >
                                                                            <div className="flex items-center gap-2">
                                                                                <ArticleIcon fontSize="small" className="text-gray-400 group-hover:text-green-500 transition-colors duration-200" />
                                                                                <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900 transition-colors duration-200">
                                                                                    {fileName}
                                                                                </span>
                                                                            </div>
                                                                            <Tooltip title="Remove track">
                                                                                <IconButton
                                                                                    edge="end"
                                                                                    onClick={() => removeTrack(track, 'selectedTracks')}
                                                                                    size="small"
                                                                                    className="text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors duration-200"
                                                                                >
                                                                                    <DeleteIcon fontSize="small" />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                        
                                                        {selectedTracks.filter(track => !track.endsWith('.bam')).length > 0 && (
                                                            <div className="mt-2 text-xs text-right text-gray-500">
                                                                {selectedTracks.filter(track => !track.endsWith('.bam')).length} track(s) selected
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Similar enhanced styling for other sections */}
                                                {selectedFiles && selectedFiles.length > 0 && (
                                                    <div className="bg-gray-50 rounded-xl p-4 transition-all duration-300 hover:shadow-md">
                                                        <div className="flex items-center gap-2 mb-3">
                                                            <div className="w-2 h-10 bg-green-500 rounded-full"></div>
                                                            <Typography variant="subtitle1" className="font-semibold text-gray-700">
                                                                Alignment Tracks
                                                            </Typography>
                                                        </div>
                                                        
                                                        <div className="flex flex-wrap gap-2">
                                                            {selectedFiles.map((file, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    label={file.split('/').pop()}
                                                                    onDelete={() => removeTrack(file, 'selectedFiles')}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    className="bg-white transition-all duration-200 hover:bg-gray-100"
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </Box>

                                </Box>
                            </Box>
                        </Paper>
                    </motion.div>
                )}
            </AnimatePresence>


            {/* JBrowse2 Session */}
            <CurrentSession
                assembly={currentAssembly}
                tracks={currentTracks}
                selectedTracks={selectedTracks}
                session={currentSession}
                setCurrentSession={setCurrentSession}
                chromosome={currentChromosome}
                selectedAssembly={selectedAssembly}
                setCurrentTracks={setCurrentTracks}
                currentUser={currentUser}
                selectedVariants={selectedVariants}
                setSelectedVariants={setSelectedVariants}
                accessVariantIsOpen={accessVariantIsOpen}
                setAccessVariantIsOpen={setAccessVariantIsOpen}
                blastModalIsOpen={blastModalIsOpen}
                setBlastModalIsOpen={setBlastModalIsOpen}
                blastData={blastData}
                setBlastData={setBlastData}
                loading={loading}
                setLoading={setLoading}
                sampleNames={sampleNames}
                setSampleNames={setSampleNames}
                notesIsOpen={notesIsOpen}
                setNotesIsOpen={setNotesIsOpen}
                notes={notes}
                setNotes={setNotes}
                createTracks={createTracks}
                createDefaultSession={createDefaultSession}
                setSelectedTracks={setSelectedTracks}
                location={location}
                setLocation={setLocation}
                state={state}
                setState={setState}
                selectedCrop={selectedCrop}
                // setShowLiteratureSearch={setShowLiteratureSearch}
                toggleLiteratureSearch={toggleLiteratureSearch}
                setToggleLiteratureSearch={setToggleLiteratureSearch}
                chromosomes={chromosomes}
                availableAssemblies={availableAssemblies}
                literatureModalIsOpen={literatureModalIsOpen}
                setLiteratureModalIsOpen={setLiteratureModalIsOpen}
                setShowToolsModal={setShowToolsModal}
            />

            {vcfModalIsOpen && (
                <VcfModal
                    vcfModalIsOpen={vcfModalIsOpen}
                    setVcfModalIsOpen={setVcfModalIsOpen}
                    sampleNames={sampleNames}
                    selectedVcfSamples={selectedVcfSamples}
                    setSelectedVcfSamples={setSelectedVcfSamples}
                    selectedTracks={selectedTracks}
                    setSelectedTracks={setSelectedTracks}
                />
            )}

            {saveModalIsOpen && (
                <SaveSessionModal 
                    saveModalIsOpen={saveModalIsOpen}
                    setSaveModalIsOpen={setSaveModalIsOpen}
                    currentSession={currentSession}
                    setCurrentSession={setCurrentSession}
                    setLoading={setLoading}
                    currentUser={currentUser}
                    currentAssembly={currentAssembly}
                    currentTracks={currentTracks}
                    location={location}
                    setSaveAlert={setSaveAlert}
                    selectedCrop={selectedCrop}
                />
            )}

            {/* Alignment Tracks Modal */}
            {isOpen && (
                <div className="fixed z-10 inset-0 overflow-y-auto" style={{ zIndex: "1000" }}>
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 bg-black bg-opacity-60 backdrop-blur-sm">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                        </div>
                        <div
                            className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby="my-modal-title"
                            aria-describedby="my-modal-description"
                        >
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" style={{ overflow: 'auto', height: "500px" }}>
                                <button onClick={closeModal} className="float-right">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-gray-600 hover:text-gray-900 cursor-pointer">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" id="my-modal-title">
                                    Available Alignment Tracks
                                </h3>

                                <input
                                    type="text"
                                    placeholder="Search alignment tracks..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    className="w-full px-3 py-2 mb-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />

                                {alignmentError && (
                                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="warning">
                                        No alignment files found for that assembly.
                                    </Alert>
                                )}

                                {alignmentLoading && (
                                    <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                                )}

                                <ul className="list-unstyled ml-4">
                                    {filteredFiles.map((file, index) => (
                                        <li key={index} className="mb-2">
                                            <div className="rounded bg-light d-flex align-items-center">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                value={file.filename}
                                                                checked={selectedFiles.includes(file.filename) || false}
                                                                onChange={handleBamChange}
                                                            />
                                                        }
                                                        label={file.filename}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button
                                    onClick={closeModal}
                                    type="button"
                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                >
                                    Close
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            
            {bigWigModalIsOpen && (
                <BigWigModal 
                    setBigWigModalIsOpen={setBigWigModalIsOpen}
                    setLoading={setLoading}
                    currentUser={currentUser}
                    selectedCrop={selectedCrop}
                    setSelectedTracks={setSelectedTracks}
                    selectedTracks={selectedTracks}
                />
            )}

            {showToolsModal && (
                <ToolsModal 
                    setLiteratureModalIsOpen={setLiteratureModalIsOpen}
                    setShowToolsModal={setShowToolsModal}
                    showToolsModal={showToolsModal}
                    currentAssembly={currentAssembly}
                    currentUser={currentUser}
                    chromosomes={chromosomes}
                    selectedCrop={selectedCrop}
                    files={files}
                />
            )}

            {/* {panGenomeModalIsOpen && (
                <PanGenomeModal 
                    setPanGenomeModalIsOpen={setPanGenomeModalIsOpen}
                    location={location}
                    setLoading={setLoading}
                    currentUser={currentUser}
                    setAvailablePaf={setAvailablePaf}
                    availablePaf={availablePaf}
                    selectedAssembly={selectedAssembly}
                    setSelectedPaf={setSelectedPaf}
                    selectedPaf={selectedPaf}
                />
            )} */}

        </>
    );
}

export default WizardTool;


/** Useful Functions */
function getFileName(filePath) {
    var text = filePath;
    var parts = text.split('/');
    var name = parts.pop();
    return name;
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function parsePythonList(str) {
    // Remove the leading and trailing square brackets and split by comma
    var arr = str.slice(1, -1).split(',');

    // Trim leading and trailing spaces and single quotes from each array element
    arr = arr.map(item => item.trim().slice(1, -1));

    return arr;
}

